import React from 'react';
import { Row } from '@cuemath/comps';
import styled from 'styled-components';

import { POCHeading, POCValue, POCWrapper } from 'screens/student-details/styled-comps';

const POCValueWrapper = styled.div`
  max-width: 182px;
  overflow-wrap: break-word;
`;

const getFullName = (firstName, lastName) => {
  if (firstName && lastName) {
    return firstName + ' ' + lastName;
  }
  if (firstName) {
    return firstName;
  }
  if (lastName) {
    return lastName;
  }
  return '-';
};

export default function DetailedPocs({
  primaryTeacherDetails,
  parentName,
  acDetails,
  rmData,
}) {
  const { teacher_name: teacherName, teacher_captain_details: tcDetails } =
    primaryTeacherDetails || {};
  const { name: acName } = acDetails || {};
  const { first_name: tcFirstName, last_name: tcLastName } = tcDetails || {};
  const { first_name: rmFirstName, last_name: rmLastName } = rmData || {};
  const infoMap = [
    {
      id: 'Parent',
      name: parentName,
    },
    {
      id: 'Teacher',
      name: teacherName,
    },
    {
      id: 'CSM',
      name: getFullName(rmFirstName, rmLastName),
    },
    {
      id: 'AC',
      name: acName,
    },
    {
      id: 'TC',
      name: getFullName(tcFirstName, tcLastName),
    },
  ];

  return (
    <POCWrapper>
      {infoMap.map(({ id, name }) => (
        <Row>
          <POCHeading variant="eyebrow2">{id}</POCHeading>
          <POCValueWrapper>
            <POCValue variant="cta1">{name}</POCValue>
          </POCValueWrapper>
        </Row>
      ))}
    </POCWrapper>
  );
}
